import { NavLink } from 'react-router-dom'
import type { NavItem } from '../../app/navConfig'
import { cn } from '../lib/cn'

export function TabBar({ items }: { items: NavItem[] }) {
  if (items.length === 0) return null
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-20 flex border-t border-st-line bg-st-surface/95 backdrop-blur md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to.split('/').length === 3}
          className={({ isActive }) =>
            cn(
              'flex flex-1 flex-col items-center gap-1 py-2 text-xs font-medium',
              isActive ? 'text-st-primary' : 'text-st-muted',
            )
          }
        >
          <item.Icon className="h-5 w-5" />
          {item.label}
        </NavLink>
      ))}
    </nav>
  )
}
